import { Action } from '@ngrx/store';
import { AppMessage } from '../model/app-message.model';

export const MESSAGE_SHOW = '[Message] Show';
export const MESSAGE_HIDE = '[Message] Hide';

/**
 * Application info message.
 */
export class MessageShowAction implements Action {
    readonly type = MESSAGE_SHOW;

    constructor(public payload: AppMessage) {};
}

/**
 * Hide message action.
 */
export class MessageHideAction implements Action {
    readonly type = MESSAGE_HIDE;

    /**
     * Payload contains message id.
     * @param {number} payload message id.
     */
    constructor(public payload: number) {};
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions = MessageShowAction
    | MessageHideAction;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/actions/message.actions.ts